import useAuthUser from "@/composables/useAuthUser";
import useHasPermissionUser from "@/composables/useHasPermissionUser";
import { RouteRecordRaw } from "vue-router";
import CreatePage from "../pages/CreatePage.vue";
import EditPage from "../pages/EditPage.vue";
import IndexPage from "../pages/IndexPage.vue";
import ShowPage from "../pages/ShowPage.vue";
import UserPermissionsPage from "../pages/UserPermissionsPage.vue";

export default {
  path: "/internal/users",
  children: [
    {
      path: "",
      name: "users.index.internal",
      component: IndexPage,
      beforeEnter: (to, from, next) => {
        const { user } = useAuthUser();

        if (!user.value?.internal) {
          return next({
            name: "users.index",
          });
        } else {
          next();
        }
      },
    },
    {
      path: ":id",
      name: "users.show.internal",
      component: ShowPage,
      beforeEnter: (to, from, next) => {
        const { isUserInternalWithPermission } = useHasPermissionUser();

        if (
          isUserInternalWithPermission("view-internal", "App\\Models\\User")
        ) {
          return next();
        } else {
          return next({
            path: "/error/not-found",
          });
        }
      },
    },
    {
      path: "create",
      name: "users.create.internal",
      component: CreatePage,
      beforeEnter: (to, from, next) => {
        const { isUserInternalWithPermission } = useHasPermissionUser();

        if (
          isUserInternalWithPermission("create-internal", "App\\Models\\User")
        ) {
          return next();
        } else {
          return next({
            path: "/error/not-found",
          });
        }
      },
    },
    {
      path: "edit/:id",
      name: "users.edit.internal",
      component: EditPage,
      beforeEnter: (to, from, next) => {
        const { isUserInternalWithPermission } = useHasPermissionUser();

        if (
          isUserInternalWithPermission("update-internal", "App\\Models\\User")
        ) {
          return next();
        } else {
          return next({
            path: "/error/not-found",
          });
        }
      },
    },
    {
      path: "permissions/:id",
      name: "users.permissions.internal",
      component: UserPermissionsPage,
      beforeEnter: (to, from, next) => {
        const { hasPermissionUser } = useHasPermissionUser();

        if (hasPermissionUser("update-internal", "App\\Models\\User")) {
          return next();
        } else {
          return next({
            path: "/error/not-found",
          });
        }
      },
    },
  ],
} as RouteRecordRaw;
